import { USER_ES } from './users'

export default {
  ...USER_ES
}
